<template>
  <div class="app-container">
    <list ref="list" @setDetails="setDetails">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <!-- <el-button size="mini" type="success" plain @click="onExport">导出</el-button> -->
          <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="info" @click="onPrintTemaplate">打印模板</el-button>
        <!-- <el-button  size="mini" class="filter-item" type="danger" @click="delRows" >删除</el-button> -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          >中止</el-button
        >
          </template>
        </el-table-column> -->
        <el-table-column label="操作" fixed="right" align="center" width="155">
          <template slot-scope="{ row }">
            <el-button type="text" @click="copy(row)">复制</el-button>
            <!-- <el-button type="text" v-if="row.Status==2" @click="editById(row.OrderId)">查看</el-button> -->
            <el-button type="text" v-if="row.Status!=2" @click="editById(row.OrderId)">编辑</el-button>
            <el-button type="text" @click="check(row)">审核</el-button>
            <el-button @click="onPrint2(row)" type="text">打印2</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="delRows(row.OrderId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px;">
      <span>订单详情</span>
      <div class="list-detail">
        <span>订单号：{{row.OrderNo||'-'}}</span>
        <span>业务员：{{row.ClerkName||'-'}}</span>
        <span>备注：{{row.Remark||'-'}}</span>
        <span>订单金额：{{ Math.floor(row.Amount*100)/100||'-' }}</span>
      </div>
    </div>
    <div class="thinScroll" :style="'px;overflow-y:auto;width:100%'">
      <el-row class="mb0">
        <el-table
          :data="Details"
          size="mini"
          border
          style="width:100%;">
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column prop="GoodsCode" label="条码" align="center" min-width="100"/>
          <el-table-column prop="GoodsName" label="商品名称" align="center" />
          <el-table-column prop="Model" label="规格型号" align="center" />
          <el-table-column prop="UnitName" label="单位" align="center"/>
          <el-table-column prop="ExistQuantity" label="现存量" align="center"/>
          <el-table-column prop="AvailableQuantity" label="可用量" align="center"/>
          <el-table-column prop="Offer" label="报价" align="center">
            <template slot-scope="{ row }">
              {{$commonJs.toThousands(row.Offer)}}
            </template>
          </el-table-column>
          <el-table-column prop="Discount" label="折扣%" width="90" align="center"/>
          <el-table-column prop="Price" label="单价" width="90" align="center">
            <template slot-scope="{ row }">
              {{$commonJs.toThousands(row.Price)}}
            </template>
          </el-table-column>
          <el-table-column prop="TaxRate" label="税率/%" width="90" align="center"/>
          <el-table-column prop="Quantity" label="数量" width="90" align="center"/>
          <el-table-column prop="TaxAmount" label="税额" width="90" align="center">
            <template slot-scope="{ row }">
              {{$commonJs.toThousands(row.TaxAmount)}}
            </template>
          </el-table-column>
          <el-table-column prop="Amount" label="含税金额" width="90" align="center">
            <template slot-scope="{ row }">
              {{$commonJs.toThousands(row.Amount)}}
            </template>
          </el-table-column>
          <el-table-column prop="NoTaxAmount" label="不含税金额" width="90" align="center">
            <template slot-scope="{ row }">
              {{$commonJs.toThousands(row.NoTaxAmount)}}
            </template>
          </el-table-column>
          <el-table-column prop="PromotionType" label="参与活动" width="100px">
              <template slot-scope="{ row }">
                    <span>{{row.PromotionType==0?'团购':row.PromotionType==1?"秒杀":row.PromotionType==2?"折扣%":""}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="ReferenceCost" label="预估成本单价" width="100">
            <template slot-scope="{ row }">
              {{$commonJs.toThousands(row.ReferenceCost)}}
            </template>
          </el-table-column>
          <el-table-column prop="GrossProfit" label="毛利">
            <template slot-scope="{ row }">
              {{$commonJs.toThousands(row.GrossProfit)}}
            </template>
          </el-table-column>
          <el-table-column prop="Remark" label="备注" width="150px"/>
        </el-table>
      </el-row>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sales/business/salesorder/list";
import editDialog from "@/components/sales/business/salesorder/editDialog";

export default {
  name: "comment",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      api: require("@/api/sale/sales").default,
      Details: [],
      row: {},
    }
  },
  methods: {
    onPrintTemaplate() {
      var url = location.origin + "/#/customprint/" + "销售订单";
      window.open(url, "_blank");
    },
    onPrint2(row) {
      var url = location.origin + "/#/customprintview/销售订单/" + row.OrderId;
      window.open(url, "_blank");
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    setDetails(list,row) {
      
      this.Details = list;
      this.row = row
    },
    // details(id) {
    //   this.$refs.editDialog.openDetailsById(id)
    // },
    check(row) {
      sessionStorage.setItem('check','1')
      this.editById(row.OrderId)
    },
    delRows(id) {
    this.$confirm("确认删除数据吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.api.delete(id).then(res => {
          if(res.Code ==0) {
            this.$message.success("删除成功")
            this.$refs.list.reload();
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
      .catch(() => {});
    },
    copy(row){
      this.api.info(row.OrderId).then((res)=>{
        if(res.Code==0){          
         
          res.Data.Goods.forEach(x => {
            x.OrderId=0;
            x.OrderGoodsId=0;
            x.T=0;
          });
          res.Data.Receipts.forEach(x => {
            x.OrderId=0;
            x.OrderReceiptId=0;
          });
          let data={...res.Data,OrderId:0,OutStatus:0,ReceiptStatus:0,Status:0,InvoiceStatus:0,CompleteStatus:0,SaleDocStatus:0,DeliveryDate:""}
          this.$refs.editDialog.openCreate(data);
        }     
         
      })
    }
  },
};
</script>